import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";

const initState = {
  groupName: null,
  groupTypeId: null,
  parentTypeId: null,
  isGroupTypeIdDisabled: false,
};
export const WorkGroupMappingFormData = {
  name: "WorkGroupMappingFormData",
  initialState: initState,
  section: [
    {
      title: "WorkGroupMapping Form",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "WorkGroupMapping Form",
          style: {
            groupStyle: "col-lg-12 col-md-12",
          },
          groupWrapper: <div className="row"></div>,
          fields: [
            {
              id: "groupName",
              label: "Group Name",
              Field_Name: "Group Name",
              fieldType: FormFieldTypes.INPUT,
              dataField: "groupName",
              fieldSetting: {
                placeholder: "Group Name",
                allowSpace: true,
              },
              validation: [
                { type: validationTypes.REQUIRE },
              ],
              style: {
                containerCss: "col-lg-4 col-md-6",
              },
            },
            {
              id: "groupTypeId",
              label: "Group Type",
              Field_Name: "Group Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "groupTypeId",
              fieldSetting: {
                placeholder: "Select",
                allowSpace: true,
                options: [],
                // isDisable: true,
                // isDisable: initState.isGroupTypeIdDisabled,

              },
              validation: [
                { type: validationTypes.REQUIRE },
              ],

              style: {
                containerCss: "col-lg-4 col-md-6",
              },

            },
          ],
        },
      ],
    },
  ],
};
